/** @jsx jsx */
// ^ https://emotion.sh/docs/css-prop#jsx-pragma ^
import { useEffect } from 'react'
import ReactDOMServer from 'react-dom/server'
import { string } from 'prop-types'
import { css, Global, jsx } from '@emotion/core'
import { isBrowser } from '@jelly/utils'

const NatomsGlobalCss = () => (
	<Global
		styles={css`
			.ntShoppingWidget {
				height: 55px;
				margin: 0.5rem 0.5rem 3rem;
				visibility: hidden;
			}
		`}
	/>
)

export function NatomsComponent({ image, buttonText = 'Learn More', title }) {
	return (
		<div
			css={{
				alignItems: 'center',
				backgroundColor: '#F2F5F7',
				borderRadius: '4px',
				boxShadow: '0 0 5px rgba(0, 0, 0, 0.5)',
				cursor: 'pointer',
				display: 'flex',
				margin: '0.5rem 0 3rem',
				height: '55px',
				width: '100% ',
			}}
			data-image={image}
			data-provider={buttonText}
			data-title={title}
		>
			<img
				alt={title}
				data-src={image}
				className="lazyload"
				css={{
					backgroundRepeat: 'no-repeat',
					backgroundSize: '100% 100%',
					borderRadius: '4px',
					height: '55px !important',
					margin: '0 1rem 0 0',
					width: '55px !important',
				}}
			/>
			<div css={{ color: '#106488', flex: '1' }}>{title}</div>
			<button
				css={{
					background: '#1BA4DE',
					border: '2px solid #1BA4DE',
					color: 'white',
					cursor: 'pointer',
					display: 'block',
					fontSize: '0.8rem',
					height: '55px',
					letterSpacing: '2.4px',
					textAlign: 'center',
					transition: 'all 0.4s ease',
					width: '150px',
					'&:hover': {
						background: '#106488',
						border: '2px solid #106488',
					},
				}}
			>
				{buttonText}
			</button>
		</div>
	)
}

NatomsComponent.propTypes = {
	buttonText: string.isRequired,
	image: string.isRequired,
	title: string.isRequired,
}

export function withNatoms(Component) {
	return (props) => {
		useEffect(() => {
			const natomsSetup = () => {
				// Gather all cases where natoms are called
				const natoms = [...document.getElementsByClassName('ntShoppingWidget')]

				if (natoms.length > 0) {
					// If there are elements, we add the attributes needed to load the natom
					natoms.forEach((element) => {
						const thumbnail = element.getAttribute('data-image')
						const linkText = element.getAttribute('data-title')
						const url = element.getAttribute('data-url')
						const provider = element.getAttribute('data-provider')
						element.classList.add('affiliateBuy')
						element.setAttribute('onClick', `window.open('${url}')`)
						element.innerHTML = ReactDOMServer.renderToString(
							<NatomsComponent image={thumbnail} buttonText={provider} title={linkText} />
						)
						element.classList.remove('ntShoppingWidget')
					})
				}
			}
			isBrowser() && document.readyState === 'complete'
				? natomsSetup()
				: window.addEventListener('load', natomsSetup)
		}, [])

		return (
			<div>
				<NatomsGlobalCss />
				<Component {...props} />
			</div>
		)
	}
}
